<template>
  <div>
    <div class="page-title-header">
      <BreadCrumb
        parentRouteName="CustomerList"
        :extra-items="[
          {
            text: customer.name,
            to: 'CustomerDetailView',
            params: { customerID: this.customer.id },
          },
          '代客註冊'
        ]"
      />
    </div>

    <b-card>
      <b-overlay :show="showLoading" rounded="sm">
        <div class="row mb-2 align-items-center">
          <div class="col-12 col-xl-6">
            <h4 class="font-weight-bold">代客註冊 - {{ customer.name }}</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-xl-8">
            <div class="mb-4">
              來源通路: {{ customer.merchant.type_name }}({{ customer.merchant.name }})
            </div>
            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label="Line 使用者名稱"
            >
              <b-form-input v-model="customer.name" :disabled="true"></b-form-input>
            </b-form-group>
            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label="識別編號"
            >
              <b-form-input v-model="customer.outer_code"  :disabled="true"></b-form-input>
            </b-form-group>
            <DynamicFormDashboard
              ref="dynamicForm"
              :input-subjects="inputSubjects"
              v-model="dynamicFormData"
            />
          </div>
        </div>
        <div v-if="hasSubmittedRegistration" class="mt-4">
          <h5 class="font-weight-bold text-left">註冊結果</h5>
          <code class="d-block" v-html="registrationResult"></code>
        </div>
        <div class="d-flex justify-content-center mt-5">
          <b-button class="mr-4" variant="outline-danger" @click="handleCancel">
            <template>返回</template>
          </b-button>
          <b-button variant="success" @click="handleSubmit">
            <template>送出</template>
          </b-button>
        </div>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import customerApi from "@/apis/customer";
import DynamicFormDashboard from "@/components/DynamicForm/DynamicFormDashboard.vue";
import BreadCrumb from "@/components/Dashboard/BreadCrumb.vue";
import _ from 'lodash';
import { mapState, mapGetters } from "vuex";

export default {
  components: { BreadCrumb, DynamicFormDashboard },
  data() {
    return {
      showLoading: false,
      customer: {
        merchant: {},
      },
      dynamicFormData: {},
      hasSubmittedRegistration: false,
      registrationResult: '',
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    ...mapGetters({
      getModuleConfig: "dashboardModule/getConfig",
    }),
    inputSubjects() {
      const subjects = this.getModuleConfig('member_register', 'member_fields', this.customer.merchant_id) ?? [];
      return _.sortBy(subjects, "order")
        .filter(subject => false === ['name', 'outer_code'].includes(subject.matched_key))
        .map(subject => {
          if (subject.type === 'date') {
            return { ...subject, _id: subject.matched_key, type: 'datetime', format: 'date' }
          } else if (subject.type === 'branch') {
            return { ...subject, _id: subject.matched_key, type: 'shop_selection', branch_provider: subject.provider }
          } else {
            return { ...subject, _id: subject.matched_key }
          }
        })
    },
  },
  async mounted() {
    this.showLoading = true;
    await Promise.all([
      this.getCustomer(),
      this.fetchModuleConfig(),
    ])
    this.$nextTick(() => {
      this.$refs.dynamicForm?.fetchAllAsyncOptions();
    });
    this.showLoading = false;
  },
  methods: {
    async fetchModuleConfig() {
      await this.$store.dispatch('dashboardModule/fetchModules', {
        org_id: this.organization.id,
        code: 'member_register'
      });
    },
    async getCustomer() {
      try {
        this.customer = _.get(await customerApi.getCustomer(this.$route.params.customerID), 'data')
      } catch (e) {
        console.log(e);
      }
    },
    handleCancel() {
      this.$router.push({
        name: 'CustomerDetailView',
        params: { customerID: this.customer.id },
      });
    },
    async handleSubmit() {
      const isValid = await this.$refs.dynamicForm.validate()
      if (!isValid) {
        return
      }

      this.hasSubmittedRegistration = true
      this.showLoading = true;

      try {
        const payload = {
          ...this.dynamicFormData
        }
        await customerApi.registerCustomer(this.customer.id, payload);
        this.registrationResult = '註冊成功';
        // this.$swal('註冊成功', '', 'success')
        //   .then(() => {
        //     this.$router.push({
        //       name: 'CustomerDetailView',
        //       params: { customerID: this.customer.id },
        //     });
        //   });
      } catch (error) {
        console.error(error);
        // this.$swal('註冊失敗', _.get(error, 'response.data.message', '發生未知錯誤'), 'error')
        this.registrationResult = _.get(error, 'response.data.message', '發生未知錯誤');
      } finally {
        this.showLoading = false;
      }
    },
  },
};
</script>
